<template>
  <div class="s-modal__wrapper s-modal__wrapper--white">
    <div class="s-modal__header s-modal__header--transparent">
      <button id="s-modal-success-close"
              type="button"
              class="s-modal__btn--close"
              aria-label="Close"
              @click="$emit('closePopup')"></button>
    </div>

    <div class="s-modal__body s-modal__body--success">
      <div class="s-modal__label s-modal__label--success" :class="{ peng: type === 'runner', jb: isJb }">
      </div>
      <div
        v-if="isPoint"
        class="s-modal-content__wrap"
      >
        <div class="s-modal-content--score__wrap point">
          당신의 점수는 {{point}}점 입니다!
        </div>
      </div>
      <div
        v-else
        class="s-modal-content__wrap"
      >
        <div class="s-modal-content--score__wrap">
          <span class="s-modal-content--score s-modal-content--score--time">{{clearMin | addZero }}:{{clearSec | addZero}}</span>
        </div>
        <div class="s-modal-content--score__wrap">
          <span class="s-modal-content--score s-modal-content--score--block">{{workCount}}{{type === 'runner' ? '개 사용' : `/${maxWorkCount}`}}</span>
        </div>
      </div>

      <div class="s-modal__btn__wrap">
        <button class="s-modal__btn--ws red s-modal__btn--ws--options" @click="cancel">재시작</button>
        <button class="s-modal__btn--ws blue s-modal__btn--ws--options" @click="confirm">다음</button>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'modalSuccessTemplate',
        props : {
          data: {
            type: Object,
            default: () => { return {} }
          },
          type: {},
          cat: {},
          isJb: {}
        },
        filters: {
            addZero(number) {
                return number < 10 ? `0${number}` : number;
            }
        },
        data() {
          return {
            clearTime: null,
            isCalled: false,
            clearMin: 0,
            clearSec: 0,
            mainSrc: '/codmos/static/assets/logicong-study-resources/sound/suc_sound.mp3',
            mainSound: {},
            point: 0,

            workCount: this.data.workCount,
            maxWorkCount: this.data.maxWorkCount
          }
        },
        computed: {
          isPoint() {
            return this.cat === 'ESOF02_1_6_1'
          }
        },
        methods: {
          cancel() {
            this.$emit('cancel', function () {
              this.$refs.gamecanvas.restartCanvas()
            })
          },
          confirm() {
            this.$emit('confirm', function () {
              this.transmitNextMission()
              this.$refs.gamecanvas.restartCanvas()
            })
          },
          clear() {
            if (this.isPoint) {
              this.point = 0;
              const { point = 0 } = this.data;
              this.mainSound.play();
              if (point > 0) {
                const TIMEOUT_FUNC = () => {
                  if (this.point >= point) {
                    this.point = point;
                  } else {
                    this.point += 4;
                    setTimeout(TIMEOUT_FUNC, 15);
                  }
                };

                setTimeout(TIMEOUT_FUNC, 15);
              }
            } else {
              this.clearTime = this.data.clearTime ? parseInt(this.data.clearTime) : 0;

              this.isCalled = true;
              this.clearMin = 0;
              this.clearSec = 0;
              const CLEAR_MIN = parseInt(this.clearTime / 60);

              const CLEAR_SEC = parseInt(this.clearTime % 60);

              this.mainSound.play();

              if (this.clearTime > 0) {
                const TIMEOUT_FUNC = () => {
                  if (this.clearMin === CLEAR_MIN && this.clearSec === CLEAR_SEC) return;
                  if (this.clearMin !== CLEAR_MIN) this.clearMin++;
                  if (this.clearSec !== CLEAR_SEC) this.clearSec++;
                  setTimeout(TIMEOUT_FUNC, 15);
                };

                setTimeout(TIMEOUT_FUNC, 15);
              }
            }
          }
        },
        mounted() {
          const sound = new Audio(this.mainSrc);
          this.mainSound = {
              play: () => {
                if (window.LC_VOLUME) {
                  sound.volume = 1;
                  sound.play();
                }
              }
          };
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/stage/modal/ModalPartialSuccess.vue